import { UrlField } from '@shared/data/entity/fields/UrlField';

/** A URL field as one line of text: the first link, and a "+N" for any more. */
export function getUrlText(field: UrlField): string {
  const [first, ...more] = field.items;
  const url = first?.url ?? '';
  return more.length > 0 ? `${url} +${more.length}` : url;
}
